import { AppAction, GeneralActions } from '../actions';
import { ApiCaller } from '../../config';
import { put, delay } from 'redux-saga/effects';
import { Utils } from '../../config';

export default class AppMiddleware {
    static *SignIn(params) {
        const { payload, cb } = params;
        const fcmToken = localStorage.getItem('fcmToken') || ''
        console.log(payload, "payload", fcmToken, "fcmToken");
        const data = {
            ...payload,
            fcmToken: fcmToken
        }
        try {
            let res = yield ApiCaller.Post('/user/login', data);
            console.log("my resp:", res?.data);
            if (res.status == 200) {
                localStorage.setItem('user', JSON.stringify(res?.data?.data));
                // authtoken seperately for the interceptor only.
                localStorage.setItem(
                    'authToken',
                    JSON.stringify(res?.data?.data.token),
                );
                yield put(AppAction.SignInSuccess(res?.data));
                yield put(GeneralActions.SetNotificationCount(res?.data?.data?.unreadNotifications))
                if (cb) {
                    console.log('andar');
                    cb();
                }

                Utils.showMessage('success', res?.data?.message);
                console.log('SignIn Response', res);
            } else {
                yield put(AppAction.SignInFailure());
                console.log('here');
                Utils.showMessage('error', 'error');
            }
            console.log(res);
        } catch (err) {
            yield put(AppAction.SignInFailure());
            Utils.showMessage('error', err?.response?.data?.message);
            console.log('signin error');
        }
    }

    static *EmailVerify(params) {
        const { payload, cb } = params;
        console.log(payload);
        const email = payload?.email;
        const verification_purpose = 'Account Recovery';
        try {
            let res = yield ApiCaller.Post('/password/otp/send', {
                email,
                verification_purpose,
            });
            console.log(res);
            if (res.status == 200) {
                yield put(AppAction.EmailVerificationSuccess());
                if (cb) {
                    cb();
                }
                Utils.showMessage('success', res?.data?.message);
                localStorage.setItem('email', email);
            } else {
                yield put(AppAction.EmailVerificationFailure());
                Utils.showMessage('error', 'error');
            }
        } catch (err) {
            yield put(AppAction.SignInFailure());
            Utils.showMessage('error', err?.response?.data?.message);
            console.log(err);
        }
    }

    static *OtpVerification(params) {
        const { payload, cb } = params;
        console.log(payload, cb);

        const verification_code = payload;
        const email = localStorage.getItem('email');

        try {
            let res = yield ApiCaller.Post('/password/otp/verify', {
                verification_code,
                email,
            });
            console.log(res);
            if (res.status == 200) {
                yield put(AppAction.OTPVerificationSuccess());
                if (cb) {
                    cb();
                }
                Utils.showMessage('success', res?.data?.message);
            } else {
                yield put(AppAction.OTPVerificationFailure());
                // Utils.showMessage('error', err?.response?.data?.message)
            }

            localStorage.setItem('otp', verification_code);
        } catch (err) {
            yield put(AppAction.OTPVerificationFailure());
            Utils.showMessage('error', err?.response?.data?.message);
            console.log(err);
        }
    }

    static *ResetPassword(params) {
        const { payload, cb } = params;
        const data = {
            email: localStorage.getItem('email'),
            verification_code: localStorage.getItem('otp'),
            password: payload?.newpassword,
        };
        try {
            let res = yield ApiCaller.Post('/password/otp/reset', data);
            if (res.status == 200) {
                yield put(AppAction.PasswordResetSuccess());
                if (cb) {
                    cb();
                }
                Utils.showMessage('success', res?.data?.message);
            } else {
                yield put(AppAction.PasswordResetFaiure());
                Utils.showMessage('error', res?.message);
            }
        } catch (err) {
            yield put(AppAction.PasswordResetFaiure());
            Utils.showMessage('error', err?.response?.data?.message);
        }
    }

    static *GetCurrentUser() {
        try {
            let res = yield ApiCaller.Get(`/user`);
            if (res.status == 200) {
                yield put(AppAction.GetCurrentUserSuccess(res?.data?.data));
                return;
            }
        } catch (err) {
            yield put(AppAction.GetCurrentUserFailure());
            Utils.showMessage('error', err?.response?.data?.message);
        }
    }

    static *Logout(params) {
        const { payload, cb } = params;
        console.log(payload);
        try {
            let res = yield ApiCaller.Post('/user/logout', payload);
            if (res.status == 200) {
                localStorage.removeItem('user');
                localStorage.removeItem('authToken');
                localStorage.removeItem('email');
                // localStorage.removeItem('companyData');
                yield put(AppAction.LogoutSuccess());
                if (cb) {
                    cb();
                }
                Utils.showMessage('success', res?.data?.message);
                console.log(res);
            } else {
                yield put(AppAction.LogoutFailure());
                // Utils.showMessage('error', err?.response?.data?.message)
            }
        } catch (err) {
            yield put(AppAction.LogoutFailure());
            Utils.showMessage('error', err?.response?.data?.message);
        }
    }

    static *AddAvailability(params) {
        const { payload, cb } = params;
        console.log(payload, "dddddddd");

        try {
            let res = yield ApiCaller.Post('/availability', payload);
            if (res.status == 200) {
                yield put(AppAction.AddAvailabilitySuccess(res?.data));
                if (cb) {
                    cb();
                }
                Utils.showMessage('success', res?.data?.message || 'Availability added successfully');
            } else {
                yield put(AppAction.AddAvailabilityFailure());
                Utils.showMessage('error', res?.data?.message || 'Failed to add availability');
            }
        } catch (err) {
            yield put(AppAction.AddAvailabilityFailure());
            Utils.showMessage('error', err?.response?.data?.message || 'Something went wrong');
            console.log(err);
        }
    }

    static *GetAvailability(params) {
        const { cb } = params;
        try {
            let res = yield ApiCaller.Get('/availability');
            console.log('GET Availability Response:', res);
            if (res.status == 200) {
                yield put(AppAction.GetAvailabilitySuccess(res?.data));
                if (cb) {
                    cb(res?.data);
                }
            } else {
                yield put(AppAction.GetAvailabilityFailure());
            }
        } catch (err) {
            yield put(AppAction.GetAvailabilityFailure());
            console.log('GET Availability Error:', err);
        }
    }

    static *DeleteAvailability(params) {
        const { payload, cb } = params;
        try {
            let res = yield ApiCaller.Delete(`/availability/${payload.date}`);
            if (res.status == 200) {
                yield put(AppAction.DeleteAvailabilitySuccess(res?.data));
                if (cb) cb();
                Utils.showMessage('success', res?.data?.message || 'Preference deleted successfully');
            } else {
                yield put(AppAction.DeleteAvailabilityFailure());
                Utils.showMessage('error', 'Failed to delete preference');
            }
        } catch (err) {
            yield put(AppAction.DeleteAvailabilityFailure());
            Utils.showMessage('error', err?.response?.data?.message || 'Failed to delete preference');
        }
    }

    static *UpdateAvailability(params) {
        const { payload, cb } = params;
        const { date, ...data } = payload;
        try {
            let res = yield ApiCaller.Patch(`/availability/${date}`, data);
            if (res.status == 200) {
                yield put(AppAction.UpdateAvailabilitySuccess(res?.data));
                if (cb) cb();
                Utils.showMessage('success', res?.data?.message || 'Preference updated successfully');
            } else {
                yield put(AppAction.UpdateAvailabilityFailure());
                Utils.showMessage('error', 'Failed to update preference');
            }
        } catch (err) {
            yield put(AppAction.UpdateAvailabilityFailure());
            Utils.showMessage('error', err?.response?.data?.message || 'Failed to update preference');
        }
    }
}
